import { cn } from 'util/cn'

import axiosOriginal from 'axios'
import { css } from 'design'
import { Button } from 'primitives/button'
import { Stack } from 'primitives/containers'
import React, { useContext, useEffect, useState } from 'react'

import { AppLocationContext } from '../../admin/app_location_provider'
import { questionContainerStyles } from './styles'

type Props = {
  url: string
}

export const ProductPreview = ({ url }: Props) => {
  const [cartData, setCartData] = useState()
  const [productData, setProductData] = useState()
  const [selectedVariant, setSelectedVariant] = useState()
  const { setAppLocation } = useContext(AppLocationContext)

  useEffect(() => {
    if (url) {
      window.cartCallback = (result: any) => {
        setCartData(result)
      }

      const s = document.createElement('script')
      s.type = 'text/javascript'
      const { protocol, hostname } = new URL(url)
      s.src = `${protocol}//${hostname}/cart.json?callback=cartCallback`
      document.head.appendChild(s)
    }
  }, [url])

  useEffect(() => {
    if (url) {
      axiosOriginal.get(`${url}.json`).then((result) => {
        setProductData({
          ...result.data.product,
          variants: result.data.product.variants.reduce((acc, variant) => {
            acc[variant.id] = variant
            return acc
          }, {}),
        })
      })
    }
  }, [url])

  useEffect(() => {
    if (productData) {
      setSelectedVariant(Object.keys(productData.variants)[0])
    }
  }, [productData])

  const goToProduct = () => {
    setAppLocation({
      productURL: url,
    })
  }

  return (
    <Stack>
      {productData ? (
        <Stack
          key={productData.id}
          direction={'row'}
          gap={4}
          className={questionContainerStyles()}
          css={{
            alignItems: 'flex-start',

            button: {
              width: '100%',
            },
            img: {
              maxHeight: '80px',
              objectFit: 'contain',
              borderRadius: '$3',
            },
          }}
        >
          <img src={productData.image.src} alt={productData.image.alt} />
          <Stack
            gap={2}
            css={{
              justifyContent: 'space-between',
              height: '100%',
              flexGrow: 1,
            }}
          >
            <Stack gap={1}>
              <h3>{productData.vendor}</h3>
              <p>{productData.title}</p>
            </Stack>
            <Button variant={'primary'} onClick={goToProduct}>
              {cartData &&
                new Intl.NumberFormat(
                  'en-GB', // BCP 47 language tag
                  {
                    style: 'currency', // we want a currency
                    currency: cartData.currency, // ISO 4217 currency code
                  },
                ).format(productData.variants[selectedVariant]?.price)}
            </Button>
          </Stack>
        </Stack>
      ) : (
        <i className={cn('fas fa-circle-notch fa-spin', spinnerStyles())} />
      )}
    </Stack>
  )
}

const spinnerStyles = css({
  position: 'absolute !important',
  inset: 0,
  margin: 'auto auto 80px auto',
  width: 75,
  height: 75,
  fontSize: 75,
  opacity: 0.7,
})
